"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var ArticleHeader = function ArticleHeader(_ref) {
  var title = _ref.title,
      editedAt = _ref.editedAt,
      editedBy = _ref.editedBy,
      url = _ref.url;
  return (0, _preact.h)("div", {
    className: "control-header"
  }, (0, _preact.h)("div", {
    className: "article-versions__header"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, (0, _preact.h)(_assets.default, {
    icon: "arrowBack",
    color: "#878787"
  })), (0, _preact.h)("div", {
    className: "article-versions__header-title"
  }, (0, _preact.h)("h2", null, title), editedAt && (0, _preact.h)("div", {
    className: "article-versions__header-metadata"
  }, (0, _dateFormatting.default)(editedAt), " \u2022 Changes made by ", editedBy))));
};

var _default = ArticleHeader;
exports.default = _default;